export const samples = [
  {
    templateName: 'dance-studio',
    version: 'v2',
    name: 'Dance Studio',
    link: 'https://dance-studio.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1d-gFma-t_jWPXq2BJptxHYLjkBqeFGjSN3B0M878-so/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1d-gFma-t_jWPXq2BJptxHYLjkBqeFGjSN3B0M878-so/template/preview',
    imageUrl: '/img/sheet-samples/dance-studio.jpg',
    categories: ['Events'],
    features: [
      'Content Pages',
      'Product Details Pages',
      'Customized Order Form',
      'Highlighted Items',
      'Item Variations',
      'Product Details Pages',
      'Search, Filters & Sorting'
    ]
  },
  {
    templateName: 'affiliate-storefront',
    version: 'v2',
    name: 'Affiliate Storefront',
    link: 'https://affiliate-storefront.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1bKztZJFWFIjD24LV1x5qAGV7rivC90jGHERbckL4weI/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1bKztZJFWFIjD24LV1x5qAGV7rivC90jGHERbckL4weI/template/preview',
    imageUrl: '/img/sheet-samples/affiliate-storefront.jpg',
    categories: ['Affiliate'],
    features: ['Category Pages (URL Aliases)', 'Content Pages', 'Product Details Pages', 'Search, Filters & Sorting']
  },
  {
    templateName: 'wholesale',
    version: 'v2',
    name: 'Wholesale Store',
    link: 'https://wholesale.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1ToZ3IDB8R_0Fm3MLTkfBDl3RKWs1BImOe0IEXXy2Op4/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1ToZ3IDB8R_0Fm3MLTkfBDl3RKWs1BImOe0IEXXy2Op4/template/preview',
    imageUrl: '/img/sheet-samples/wholesale.jpg',
    categories: ['E-commerce'],
    features: [
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Item Variations',
      'Product Details Pages',
      'Search, Filters & Sorting',
      'Shopping cart and Checkout'
    ]
  },
  {
    templateName: 'prompt-collection',
    version: 'v2',
    name: 'Prompt Collection',
    link: 'https://prompt-collection.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1oP-Kk1ZeC2DHmG8-OHGIDMorbtliAMZeM3PbaI2K50w/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1oP-Kk1ZeC2DHmG8-OHGIDMorbtliAMZeM3PbaI2K50w/template/preview',
    imageUrl: '/img/sheet-samples/prompt-collection.jpg',
    categories: ['Catalog/Directory'],
    features: ['Content Pages', 'Product Details Pages', 'Search, Filters & Sorting']
  },
  {
    templateName: 'tutor-directory',
    version: 'v2',
    name: 'Tutor Directory',
    link: 'https://tutor-directory.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1D0sU4PQ4kvL9VLOF5bHtIJvC91rvDVw3uGFTS3es8-o/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1D0sU4PQ4kvL9VLOF5bHtIJvC91rvDVw3uGFTS3es8-o/template/preview',
    imageUrl: '/img/sheet-samples/tutor-directory.jpg',
    categories: ['Catalog/Directory'],
    features: ['Content Pages', 'Product Details Pages', 'Search, Filters & Sorting']
  },
  {
    templateName: 'bike-store',
    version: 'v2',
    name: 'Bike Store',
    link: 'https://bike-store.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1M94jTpNl4tTFFAYr1PAbIdan33A89Q4JruSQyZa8jmA/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1M94jTpNl4tTFFAYr1PAbIdan33A89Q4JruSQyZa8jmA/template/preview',
    imageUrl: '/img/sheet-samples/bike-store.jpg',
    categories: ['E-commerce'],
    features: ['Category Pages (URL Aliases)', 'Content Pages', 'Product Details Pages', 'Search, Filters & Sorting', 'Shopping cart and Checkout']
  },
  {
    templateName: 'recruitment',
    version: 'v2',
    name: 'Recruitment Website',
    link: 'https://recruitment.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/15FvxcCNtR7WzekPlkhqFaEL_R0OJy2DeUpYGzJBHOk0/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/15FvxcCNtR7WzekPlkhqFaEL_R0OJy2DeUpYGzJBHOk0/template/preview',
    imageUrl: '/img/sheet-samples/recruitment.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'jewelry-store',
    version: 'v2',
    name: 'Jewelry Store',
    link: 'https://jewelry-store.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1cg6IIPVb2NZ37rcIL4TrKRXkz4c_dqvDHWOjQNxwAOc/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1cg6IIPVb2NZ37rcIL4TrKRXkz4c_dqvDHWOjQNxwAOc/template/preview',
    imageUrl: '/img/sheet-samples/jewelry-store.jpg',
    categories: ['E-commerce'],
    features: [
      'Search, Filters & Sorting',
      'Shopping cart and Checkout',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages',
      'Item Variations'
    ]
  },
  {
    templateName: 'stand-up',
    version: 'v2',
    name: 'Stand-up Comedy Store',
    link: 'https://stand-up.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1qZRMOhiMg4_glFfAU0_M9PcinVVWdZ2JI4NK1fRc4ik/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1qZRMOhiMg4_glFfAU0_M9PcinVVWdZ2JI4NK1fRc4ik/template/preview',
    imageUrl: '/img/sheet-samples/stand-up.jpg',
    categories: ['Events'],
    features: ['Customized Order Form', 'Content Pages', 'Product Details Pages', 'Item Variations', 'Calendar View']
  },
  {
    templateName: 'cleaning-company',
    version: 'v2',
    name: 'Cleaning Company',
    link: 'https://cleaning-company.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1xD709jPjdxXOdbYHTrf7JKbTiJM0YTj9cC1X_pjpIMg/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1xD709jPjdxXOdbYHTrf7JKbTiJM0YTj9cC1X_pjpIMg/template/preview',
    imageUrl: '/img/sheet-samples/cleaning-company.jpg',
    categories: ['Services'],
    features: ['Search, Filters & Sorting', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'book-collection',
    version: 'v2',
    name: 'Book Collection',
    link: 'https://book-collection.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1h8btBvQd72ewSV5Z3lRjbT2CgtuUtgrMzasxgZhn2_o/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1h8btBvQd72ewSV5Z3lRjbT2CgtuUtgrMzasxgZhn2_o/template/preview',
    imageUrl: '/img/sheet-samples/book-collection.jpg',
    categories: ['Digital Downloads'],
    features: [
      'Search, Filters & Sorting',
      'Shopping cart and Checkout',
      'Content Pages',
      'Product Details Pages',
      'Digital Downloads (Secret Columns)'
    ]
  },
  {
    templateName: 'yoga-studio',
    version: 'v2',
    name: 'Yoga Studio',
    link: 'https://yoga-studio.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1dTY5zOnH1DvSMGeMBU4P_fpUtnxRD5MFAKvLunBBga0/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1dTY5zOnH1DvSMGeMBU4P_fpUtnxRD5MFAKvLunBBga0/template/preview',
    imageUrl: '/img/sheet-samples/yoga-studio.jpg',
    categories: ['Services'],
    features: ['Search, Filters & Sorting', 'Content Pages', 'Product Details Pages', 'Item Variations']
  },
  {
    templateName: 'nail-salon',
    version: 'v2',
    name: 'Nail Salon',
    link: 'https://nail-salon.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1a7tgnNzFh7cZo-clOjSd-bGDs7owB_G9e3No_TXtCuc/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1a7tgnNzFh7cZo-clOjSd-bGDs7owB_G9e3No_TXtCuc/template/preview',
    imageUrl: '/img/sheet-samples/nail-salon.jpg',
    categories: ['Services'],
    features: ['Search, Filters & Sorting', 'Shopping cart and Checkout', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'barbershop',
    version: 'v2',
    name: 'Barber Shop',
    link: 'https://barbershop.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1hv-bgb5f6NmDUlt4Fc8UPg6etZR_ht-Tc5lf7ol2ijc/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1hv-bgb5f6NmDUlt4Fc8UPg6etZR_ht-Tc5lf7ol2ijc/template/preview',
    imageUrl: '/img/sheet-samples/barbershop.jpg',
    categories: ['Services'],
    features: [
      'Search, Filters & Sorting',
      'Shopping cart and Checkout',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages',
      'Item Variations'
    ]
  },
  {
    templateName: 'handymen',
    version: 'v2',
    name: 'Handymen Directory',
    link: 'https://handymen.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1UPXlT2LFKrDQ0WWhQ6_bpTQ1SMC4Tfh0gzLdNwT23qY/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1UPXlT2LFKrDQ0WWhQ6_bpTQ1SMC4Tfh0gzLdNwT23qY/template/preview',
    imageUrl: '/img/sheet-samples/handymen.jpg',
    categories: ['Services'],
    features: ['Search, Filters & Sorting', 'Customized Order Form', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'tire-store',
    version: 'v2',
    name: 'Tire Store',
    link: 'https://tire-store.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1YOw-tIJgHj8CU2Ou55NqQz33nWRMA2whpD1ZyTSeyUs/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1YOw-tIJgHj8CU2Ou55NqQz33nWRMA2whpD1ZyTSeyUs/template/preview',
    imageUrl: '/img/sheet-samples/tire-store.jpg',
    categories: ['E-commerce'],
    features: ['Search, Filters & Sorting', 'Shopping cart and Checkout', 'Content Pages', 'Product Details Pages', 'Item Variations']
  },
  {
    templateName: 'ted-podcasts',
    version: 'v2',
    name: 'TED Podcasts',
    link: 'https://ted-podcasts.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1zsbYnGUDEa9KOuvWK-PWfmwF-KeIdoK8AQvv_xuRO6M/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1zsbYnGUDEa9KOuvWK-PWfmwF-KeIdoK8AQvv_xuRO6M/template/preview',
    imageUrl: '/img/sheet-samples/ted-podcasts.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'recipe-collection',
    version: 'v2',
    name: 'Recipe Collection',
    link: 'https://recipe-collection.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1fvkvTcOPhRs1Ts2ckq7L4Qm5vx8HkS6B_9GzFwa9mC4/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1fvkvTcOPhRs1Ts2ckq7L4Qm5vx8HkS6B_9GzFwa9mC4/template/preview',
    imageUrl: '/img/sheet-samples/recipe-collection.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'ai-startups',
    version: 'v2',
    name: 'AI Startups',
    link: 'https://ai-startups.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1g_3eqbotjP8dtqox-_YJfWDpOfqWMAWLtqVtEc2KNYA/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1g_3eqbotjP8dtqox-_YJfWDpOfqWMAWLtqVtEc2KNYA/template/preview',
    imageUrl: '/img/sheet-samples/ai-startups.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Highlighted Items', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'law-firm',
    version: 'v2',
    name: 'Law Firm',
    link: 'https://law-firm.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1ik9-9LQqlUk5Axcj0AObYRmsWZyBwyXzuW10DGGR6rc/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1ik9-9LQqlUk5Axcj0AObYRmsWZyBwyXzuW10DGGR6rc/template/preview',
    imageUrl: '/img/sheet-samples/law-firm.jpg',
    categories: ['Services'],
    features: ['Search, Filters & Sorting', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'bakery-store',
    version: 'v2',
    name: 'Bakery Store',
    link: 'https://boulangerie.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1mYvgtafEEq_8rZXaX81orhdmnYJKw5kqC9twGsTpRfo/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1mYvgtafEEq_8rZXaX81orhdmnYJKw5kqC9twGsTpRfo/template/preview',
    imageUrl: '/img/sheet-samples/bakery-store.jpg',
    categories: ['E-commerce'],
    features: ['Search, Filters & Sorting', 'Shopping cart and Checkout', 'Category Pages (URL Aliases)', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'florist',
    version: 'v2',
    name: 'Flower Shop',
    link: 'https://florist.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1EngWepODvk-902GFSJEWE52wetbqzy85fwtsXzamPkM/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1EngWepODvk-902GFSJEWE52wetbqzy85fwtsXzamPkM/template/preview',
    imageUrl: '/img/sheet-samples/florist.jpg',
    categories: ['E-commerce'],
    features: ['Search, Filters & Sorting', 'Shopping cart and Checkout', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'car-dealer',
    version: 'v2',
    name: 'Car Dealer',
    link: 'https://car-dealer.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1XyGjxZmMkxoaKPpojVmFQRa0ewSEnsGc_6BIlOXHCsw/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1XyGjxZmMkxoaKPpojVmFQRa0ewSEnsGc_6BIlOXHCsw/template/preview',
    imageUrl: '/img/sheet-samples/car-dealer.jpg',
    categories: ['Services'],
    features: ['Search, Filters & Sorting', 'Highlighted Items', 'Shopping cart and Checkout', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'grocery-store',
    version: 'v2',
    name: 'Grocery Store',
    link: 'https://grocery-store.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1u0hUr8VhGIuiX0nzT6vJ48Wc_PXiemxo-WR9K2k_MQ4/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1u0hUr8VhGIuiX0nzT6vJ48Wc_PXiemxo-WR9K2k_MQ4/template/preview',
    imageUrl: '/img/sheet-samples/grocery-store.jpg',
    categories: ['E-commerce'],
    features: [
      'Search, Filters & Sorting',
      'Highlighted Items',
      'Shopping cart and Checkout',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages'
    ]
  },
  {
    templateName: 'templates-store',
    version: 'v2',
    name: 'Templates Store',
    link: 'https://templates-store.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1NCNARy81iyICl0OgUUlW4Vjz3YQL_2CCYoUa9IhJlS8/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1NCNARy81iyICl0OgUUlW4Vjz3YQL_2CCYoUa9IhJlS8/template/preview',
    imageUrl: '/img/sheet-samples/templates-store.jpg',
    categories: ['Digital Downloads'],
    features: [
      'Search, Filters & Sorting',
      'Highlighted Items',
      'Shopping cart and Checkout',
      'Content Pages',
      'Product Details Pages',
      'Digital Downloads (Secret Columns)',
      'Email Subscription Add-on'
    ]
  },
  {
    templateName: 'travel-agency',
    version: 'v2',
    name: 'Travel Agency',
    link: 'https://travel-agency.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1JK9KfgmfPOyoeWYZt3M8UrHE0K5HJoFX4ZrtALrc5sE/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1JK9KfgmfPOyoeWYZt3M8UrHE0K5HJoFX4ZrtALrc5sE/template/preview',
    imageUrl: '/img/sheet-samples/travel-agency.jpg',
    categories: ['Services'],
    features: [
      'Search, Filters & Sorting',
      'Map View',
      'Customized Order Form',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages',
      'Item Variations',
      'Email Subscription Add-on'
    ]
  },
  {
    templateName: 'community-center-schedule',
    version: 'v2',
    name: 'Community Center Schedule',
    link: 'https://community-center-schedule.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1LfVQd0RHuF0PiHU0jD9PHD-ZvPFJz3ou5pdwBDGXuEc/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1LfVQd0RHuF0PiHU0jD9PHD-ZvPFJz3ou5pdwBDGXuEc/template/preview',
    imageUrl: '/img/sheet-samples/community-center-schedule.jpg',
    categories: ['Catalog/Directory'],
    features: [
      'Customized Order Form',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages',
      'Item Variations',
      'Email Subscription Add-on'
    ]
  },
  {
    templateName: 'video-catalog',
    version: 'v2',
    name: 'Video Catalog',
    link: 'https://video-catalog.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1WZZgBPOQJedKWoUah4OCQlmgPp0OWr7qz_qEQmFZw8c/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1WZZgBPOQJedKWoUah4OCQlmgPp0OWr7qz_qEQmFZw8c/template/preview',
    imageUrl: '/img/sheet-samples/video-catalog.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Highlighted Items', 'Content Pages', 'Product Details Pages', 'Disqus Add-on']
  },
  {
    templateName: 'dental-clinics',
    version: 'v2',
    name: 'Dental Clinics Directory',
    link: 'https://dental-clinics-directory.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1iOXm6myoVg1sc8R5_bLtupxpDV9JuIjZap28NdIGUog/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1iOXm6myoVg1sc8R5_bLtupxpDV9JuIjZap28NdIGUog/template/preview',
    imageUrl: '/img/sheet-samples/dental-clinics.jpg',
    categories: ['Catalog/Directory'],
    features: ['Map View', 'Content Pages', 'Product Details Pages', 'Disqus Add-on', 'Email Subscription Add-on']
  },
  {
    templateName: 'clothes-store',
    version: 'v2',
    name: 'Apparel Store',
    link: 'https://clothes-store.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/u/4/d/1anPNuqP9WOprYg2CFlwbnjJASM-x1nPN6vGn4kgpztQ/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/u/4/d/1anPNuqP9WOprYg2CFlwbnjJASM-x1nPN6vGn4kgpztQ/template/preview',
    imageUrl: '/img/sheet-samples/clothes-store.jpg',
    categories: ['E-commerce'],
    features: [
      'Search, Filters & Sorting',
      'Shopping cart and Checkout',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages',
      'Item Variations'
    ]
  },
  {
    templateName: 'eco-store',
    version: 'v2',
    name: 'Eco Store',
    link: 'https://eco-store-v2.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/u/4/d/1VC9sEy3sz7jXl6-EeMbpzR9u-KH8C2UxhmzTtaNVjoo/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/u/4/d/1VC9sEy3sz7jXl6-EeMbpzR9u-KH8C2UxhmzTtaNVjoo/template/preview',
    imageUrl: '/img/sheet-samples/eco-store.png',
    categories: ['E-commerce'],
    features: [
      'Search, Filters & Sorting',
      'Shopping cart and Checkout',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages',
      'Item Variations'
    ]
  },
  {
    templateName: 'food-delivery',
    version: 'v2',
    name: 'Food Delivery + WhatsApp',
    link: 'https://food-delivery.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1USX1hO682-p0BdVCO0fwkrsxnD2T_iB8GisziIerEis/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1USX1hO682-p0BdVCO0fwkrsxnD2T_iB8GisziIerEis/template/preview',
    imageUrl: '/img/sheet-samples/food-delivery.jpg',
    categories: ['E-commerce'],
    features: [
      'Search, Filters & Sorting',
      'Shopping cart and Checkout',
      'Category Pages (URL Aliases)',
      'Content Pages',
      'Product Details Pages',
      'Item Variations',
      'WhatsApp Add-on'
    ]
  },
  {
    templateName: 'tourist-guide',
    version: 'v2',
    name: 'Tourist Guide',
    link: 'https://tourist-guide.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1ZUldamsImfZG0uplhTWUWZwIv9ySC9wVoXf4RaE7nyc/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1ZUldamsImfZG0uplhTWUWZwIv9ySC9wVoXf4RaE7nyc/template/preview',
    imageUrl: '/img/sheet-samples/tourist-guide.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Map View', 'Highlighted Items', 'Content Pages', 'Product Details Pages', 'Email Subscription Add-on']
  },
  {
    templateName: 'marketing-books',
    version: 'v2',
    name: 'Marketing Books',
    link: 'https://marketing-books.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1aAXUSRCQpPhkJzylkeDlpbLiZbsyG58zv_40PfEzIVA/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1aAXUSRCQpPhkJzylkeDlpbLiZbsyG58zv_40PfEzIVA/template/preview',
    imageUrl: '/img/sheet-samples/marketing-books.jpg',
    categories: ['Affiliate'],
    features: ['Password Protection', 'Search, Filters & Sorting', 'Content Pages', 'Product Details Pages', 'Email Subscription Add-on']
  },
  {
    templateName: 'job-board',
    version: 'v1',
    name: 'Job Board',
    link: 'https://jobboard.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/12N1ARYJlKBJ0NKBuZyEHrUA4d_JuHH5goDZk14o7Abo',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/12N1ARYJlKBJ0NKBuZyEHrUA4d_JuHH5goDZk14o7Abo/template/preview',
    imageUrl: '/img/sheet-samples/job-board.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Highlighted Items', 'Product Details Pages']
  },
  {
    templateName: 'online-courses',
    version: 'v2',
    name: 'Online Courses',
    link: 'https://online-courses-v2.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1CVwnra_WRHrifYL51f0u5eOOSPLInOh5gZKdxxwyhno/edit#gid=0',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1CVwnra_WRHrifYL51f0u5eOOSPLInOh5gZKdxxwyhno/template/preview',
    imageUrl: '/img/sheet-samples/online-courses-v2.jpg',
    categories: ['Catalog/Directory'],
    features: ['Search, Filters & Sorting', 'Content Pages', 'Product Details Pages']
  },
  {
    templateName: 'furniture',
    version: 'v2',
    name: 'Furniture Store',
    link: 'https://furniture-v2.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1jQwwmTkXEEKBBfBQDxnvsi-A00GMnsy8n1qjDVsXDEY',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1jQwwmTkXEEKBBfBQDxnvsi-A00GMnsy8n1qjDVsXDEY/template/preview',
    imageUrl: '/img/sheet-samples/furniture-v2.jpg',
    categories: ['E-commerce'],
    features: ['Search, Filters & Sorting', 'Shopping cart and Checkout', 'Product Details Pages', 'Content Pages']
  },
  {
    templateName: 'oculus-amazon',
    version: 'v2',
    name: 'Affiliate Website',
    link: 'https://oculus-referral.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1WF2iNToWU0icdz_wKt5V8qCXZaCUGgTJSq1iHcxUHUA',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1WF2iNToWU0icdz_wKt5V8qCXZaCUGgTJSq1iHcxUHUA/template/preview',
    imageUrl: '/img/sheet-samples/oculus.jpg',
    categories: ['Affiliate'],
    features: ['Search, Filters & Sorting', 'Product Details Pages', 'Content Pages']
  },
  {
    templateName: 'emoji-tees',
    version: 'v2',
    name: 'Merch Store',
    link: 'https://merch-store.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/13CciNP_LA19OFFJwYMa44vrBMH3khvdv_qiyAk4_Euo',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/13CciNP_LA19OFFJwYMa44vrBMH3khvdv_qiyAk4_Euo/template/preview',
    imageUrl: '/img/sheet-samples/merch-store.jpg',
    categories: ['E-commerce'],
    features: ['Search, Filters & Sorting', 'Shopping cart and Checkout', 'Product Details Pages', 'Content Pages']
  },
  {
    templateName: 'sushi',
    version: 'v2',
    name: 'Sushi Restaurant',
    link: 'https://sushi-restaurant-v2.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/1pNMoH4OU-co9CQT0Mua5qbZYM6BV8vPLSvjx17tb42c',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/1pNMoH4OU-co9CQT0Mua5qbZYM6BV8vPLSvjx17tb42c/template/preview',
    imageUrl: '/img/sheet-samples/sushi-restaurant-v2.jpg',
    categories: ['E-commerce'],
    features: ['Search, Filters & Sorting', 'Shopping cart and Checkout', 'Product Details Pages', 'Content Pages']
  },
  {
    templateName: 'aircc',
    version: 'v2',
    name: 'Real Estate',
    link: 'https://realestate-v2.spread.name/',
    googleDocs: 'https://docs.google.com/spreadsheets/d/14PgA97Gy-2kEQ2sDe4RcnpT4J8p29aqpU5SC2-14uB8',
    copyGoogleDocs: 'https://docs.google.com/spreadsheets/d/14PgA97Gy-2kEQ2sDe4RcnpT4J8p29aqpU5SC2-14uB8/template/preview',
    imageUrl: '/img/sheet-samples/realestate-v2.jpg',
    categories: ['E-commerce'],
    features: ['Search, Filters & Sorting', 'Map View', 'Product Details Pages', 'Content Pages']
  }
]
